function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 427.721 427.721",
  style: {
    "enableBackground": "new 0 0 427.721 427.721"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E54F4F"
  },
  d: "M69.093,210.57c0-20.564,32.902-92.947,32.902-111.865s52.643,19.741,52.643,19.741l-19.741,52.643 L69.093,210.57z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E54F4F"
  },
  d: "M358.627,210.57c0-20.564-32.902-92.947-32.902-111.865s-52.643,19.741-52.643,19.741 l19.741,52.643L358.627,210.57z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  style: {
    "fill": "#E54F4F"
  },
  cx: 213.86,
  cy: 101.995,
  rx: 111.865,
  ry: 95.415
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  style: {
    "fill": "#B8453D"
  },
  cx: 213.86,
  cy: 213.86,
  rx: 144.767,
  ry: 95.415
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFD7A3"
  },
  d: "M141.567,301.628c14.716-9.475,13.07-37.675,13.07-44.255h118.446c0,6.58-1.825,34.78,12.89,44.255 L213.86,382.4L141.567,301.628z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FDC88E"
  },
  d: "M259.923,329.757l26.051-28.129c-14.716-9.474-12.89-37.675-12.89-44.255H154.638 C163.136,281.806,219.344,323.725,259.923,329.757z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M130.354,135.944c-5.475,9.721-8.618,21.541-8.618,35.886c0,52.696,30.343,118.446,92.124,118.446 s92.124-65.75,92.124-118.446c0-14.344-3.143-26.164-8.618-35.886c-23.6-11.007-52.395-17.498-83.507-17.498 S153.954,124.936,130.354,135.944z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M124.811,176.765c-9.864-2.468-16.326,2.805-16.326,13.161c0,13.709,13.265,47.296,27.21,26.321 C149.641,195.272,124.811,176.765,124.811,176.765z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M301.235,176.765c10.767-2.468,17.821,2.805,17.821,13.161c0,13.709-14.479,47.296-29.701,26.321 S301.235,176.765,301.235,176.765z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFB422"
  },
  d: "M365.208,427.721c10.903,0,19.741-8.838,19.741-19.741v-29.821 c0-28.954-22.562-59.864-50.138-68.687l-41.168-13.173c-22.149,16.936-53.802,40.039-79.782,40.039s-57.633-23.103-79.782-40.039 L92.91,309.472c-27.576,8.823-50.138,39.733-50.138,68.687v29.821c0,10.903,8.838,19.741,19.741,19.741H365.208z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FC9B28"
  },
  d: "M334.811,309.472l-41.168-13.173c-22.149,16.936-53.802,40.039-79.782,40.039 s-57.633-23.103-79.782-40.039L92.91,309.472c-27.576,8.823-50.138,39.733-50.138,68.687v16.66h342.177v-16.66 C384.949,349.204,362.387,318.295,334.811,309.472z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#29394A"
  },
  d: "M213.86,336.337c-18.694,0-40.309-11.967-59.223-24.985v63.726l46.059,52.643h26.325l46.061-52.643 v-63.726C254.169,324.37,232.554,336.337,213.86,336.337z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFBE1E"
  },
  d: "M161.384,301.506l45.896,126.215h-26.321l-61.768-61.768c-2.316-2.316-2.576-5.981-0.611-8.601 l16.317-21.756l-33.95-11.317c-3.25-1.083-5.137-4.443-4.326-7.771c3.657-15.002,17.009-53.296,58.016-53.296v0 C154.638,276.273,156.921,289.232,161.384,301.506z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFBE1E"
  },
  d: "M266.337,301.506l-45.896,126.215h26.321l61.768-61.768c2.316-2.316,2.576-5.981,0.611-8.601 l-16.317-21.756l33.95-11.317c3.25-1.083,5.137-4.443,4.326-7.771c-3.657-15.002-17.009-53.296-58.016-53.296v0 C273.083,276.273,270.8,289.232,266.337,301.506z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FF5F50"
  },
  d: "M213.86,98.75c18.579,0,36.321,2.332,52.643,6.535V19.741C266.503,8.883,257.62,0,246.762,0 h-65.803c-10.858,0-19.741,8.883-19.741,19.741v85.544C177.539,101.082,195.281,98.75,213.86,98.75z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#7E5449"
  },
  d: "M280.852,129.283c3.757,15.454,11.972,62.288,11.972,62.288l13.161-6.58l3.623-42.666 C300.891,137.253,291.245,132.866,280.852,129.283z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#7E5449"
  },
  d: "M118.113,142.324l3.623,42.666l13.161,6.58c0,0,8.215-46.834,11.972-62.288 C136.476,132.866,126.83,137.253,118.113,142.324z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  style: {
    "fill": "#FFD267"
  },
  cx: 213.86,
  cy: 52.643,
  rx: 19.741,
  ry: 26.321
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#7E5449"
  },
  d: "M215.101,234.492c0-8.689-8.431-10.656-13.983-8.55c-10.179,3.861-21.386,14.632-30.845,7.971 c0,0,3.29,13.903,8.841,13.903C190.217,247.815,215.101,249.264,215.101,234.492z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#7E5449"
  },
  d: "M212.44,234.492c0-8.689,8.431-10.656,13.983-8.55c10.179,3.861,21.386,14.632,30.845,7.971 c0,0-3.29,13.903-8.841,13.903C237.323,247.815,212.44,249.264,212.44,234.492z"
}))), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/4.59b4e1c9.svg";
export { SvgComponent as ReactComponent };